export default __webpack_public_path__ + "static/Chupa_Chups_Raspberry-1028c39f9746e9c631fb2ef5292cf1ed.png";